'use client';

import _defineProperty from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src3207/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "scrollHideDelay", "scrollbars"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { useMergedRef } from '@mantine/hooks';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../../core/MantineProvider/use-props/use-props.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import { ScrollAreaProvider } from '../ScrollArea.context.mjs';
var defaultProps = {
  scrollHideDelay: 1e3,
  type: "hover"
};
var ScrollAreaRoot = forwardRef(function (_props, ref) {
  var props = useProps("ScrollAreaRoot", defaultProps, _props);
  var type = props.type,
    scrollHideDelay = props.scrollHideDelay,
    scrollbars = props.scrollbars,
    others = _objectWithoutProperties(props, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollArea = _useState2[0],
    setScrollArea = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    viewport = _useState4[0],
    setViewport = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    content = _useState6[0],
    setContent = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    scrollbarX = _useState8[0],
    setScrollbarX = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    scrollbarY = _useState10[0],
    setScrollbarY = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    cornerWidth = _useState12[0],
    setCornerWidth = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    cornerHeight = _useState14[0],
    setCornerHeight = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    scrollbarXEnabled = _useState16[0],
    setScrollbarXEnabled = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    scrollbarYEnabled = _useState18[0],
    setScrollbarYEnabled = _useState18[1];
  var rootRef = useMergedRef(ref, function (node) {
    return setScrollArea(node);
  });
  return /* @__PURE__ */jsx(ScrollAreaProvider, {
    value: {
      type: type,
      scrollHideDelay: scrollHideDelay,
      scrollArea: scrollArea,
      viewport: viewport,
      onViewportChange: setViewport,
      content: content,
      onContentChange: setContent,
      scrollbarX: scrollbarX,
      onScrollbarXChange: setScrollbarX,
      scrollbarXEnabled: scrollbarXEnabled,
      onScrollbarXEnabledChange: setScrollbarXEnabled,
      scrollbarY: scrollbarY,
      onScrollbarYChange: setScrollbarY,
      scrollbarYEnabled: scrollbarYEnabled,
      onScrollbarYEnabledChange: setScrollbarYEnabled,
      onCornerWidthChange: setCornerWidth,
      onCornerHeightChange: setCornerHeight
    },
    children: /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({}, others), {}, {
      ref: rootRef,
      __vars: {
        "--sa-corner-width": scrollbars !== "xy" ? "0px" : "".concat(cornerWidth, "px"),
        "--sa-corner-height": scrollbars !== "xy" ? "0px" : "".concat(cornerHeight, "px")
      }
    }))
  });
});
ScrollAreaRoot.displayName = "@mantine/core/ScrollAreaRoot";
export { ScrollAreaRoot };